import { render, staticRenderFns } from "./dynamic-submodule-1.vue?vue&type=template&id=2444bdb2&"
import script from "./dynamic-submodule-1.vue?vue&type=script&lang=js&"
export * from "./dynamic-submodule-1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports